import { queryOptions } from "@tanstack/react-query";
import { fetchOccPageData } from "./pageDataClient";
import { pageDataKeys } from "./pageDataKeys";
import type { PageInitialDataResult } from "./pageInitialDataTypes";
import type { SelfRegistrationPageInitialData } from "./selfRegistrationPageInitialData";

export const selfRegistrationPageQueryOptions = () =>
  queryOptions({
    queryKey: pageDataKeys.page("become-schaeffler-customer"),
    queryFn: () =>
      fetchOccPageData<PageInitialDataResult<SelfRegistrationPageInitialData>>("/page-data/become-schaeffler-customer"),
    staleTime: 0,
    gcTime: 0,
    refetchOnWindowFocus: false,
    retry: 1,
  });
